<template>
  <div class="leftres">
    <div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;">
        <InformationPublishtable :tableData="tabledata" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></InformationPublishtable>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import InformationPublishtable from './components/InformationPublishtable.vue'
import { InformationList, } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    InformationPublishtable
  },
  data() {
    return {
      showorhide: false,
      pageSize: 20,
      pageIndex: 1,
      total: 0,
      formdata: [
        {
          inputdata: "",
          title: '文件名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '220px'
        },
        {
          inputdata: '',
          title: "上传时间",
          fontSize: "14px",
          color: "#333333",
          placeholder: "请输入",
          types: "",
          inputtype: "date",
          width: "140px",
          //   lablewith: '95px'
        },
      ],
      tabledata: [],

    }
  },
  created() {
   
  },
  mounted() {
 this.InformationList()
  },
  methods: {
    async InformationList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message,
      } = await InformationList({
         IsForEdit: 1,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.tabledata = data.data
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    handleCurrentChange(PageIndex) {
      this.pageIndex = PageIndex
      this.InformationList()
    },
    handleSizeChange(PageSize) {
      this.pageSize = PageSize
      this.InformationList()
    },
    
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  animation: shows 0.2s ease-in;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  overflow: hidden;
  // animation: hides 0.5s ease-in;
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 40px;
  }
}
@keyframes hides {
  0% {
    height: 40px;
  }
  100% {
    height: 0px;
  }
}
</style>